import {isBrowser} from "utils/browser"
export * from "gatsby-plugin-react-i18next"

export const GATSBY_I18NEXT_KEY = "gatsby-i18next-language"
export const BACKUP_GATSBY_I18NEXT_KEY = `${GATSBY_I18NEXT_KEY}-backup`
export const DEFAULT_LANGUAGE = "en"
export const SUPPORT_LANGUAGES = (process.env.I18N_LOCALES || "")
  .split(",")
  .map(language => language.trim())
  .filter(Boolean)

function assertSupportLanguages() {
  if (SUPPORT_LANGUAGES.length === 0) {
    throw new Error("Required environment variable I18N_LOCALES is not set")
  }
}

/**
 * @param {string | null | undefined} language
 */
export function isSupportedLanguage(language) {
  assertSupportLanguages()
  return !!language && SUPPORT_LANGUAGES.includes(language)
}

/**
 * @param {string | null | undefined} language
 */
export function normalizeLanguage(language) {
  if (!language) return undefined
  return isSupportedLanguage(language) ? language : DEFAULT_LANGUAGE
}

export function getLanguageFromLocation() {
  if (typeof window === "undefined") return undefined
  const {pathname} = window.location

  assertSupportLanguages()

  for (const supportedLanguage of SUPPORT_LANGUAGES) {
    if (pathname.startsWith(`/${supportedLanguage}/`)) {
      return supportedLanguage
    }
  }

  return undefined
}

/**
 * prepend the path the language found in GATSBY_I18NEXT_KEY local storage,
 * for example,
 * getLanguagePathFromStorage("/profile") => "/en/profile"
 *
 * NOTE:
 * usually, you don't need to do this, just use the navigate from useI18next
 * however, we found out there're sometimes, especially in safari,
 * when we use some hook's on success or on error to redirect to pages,
 * for example, in the "index page", "sign-in page", or the "useCognitoUser" hook
 *
 * the 18next context is not ready yet (because the plugin is about to redirect,
 * it would return null in plugin's wrapPageElement),
 * so when calling useI18next, it doesn't give the correct value
 *
 * hence, only at these places, would use this method to navigate
 * @param {string} path
 */
export function getLanguagePathFromStorage(path = "") {
  if (typeof window === "undefined") return path

  const i18nextLanguage = normalizeLanguage(
    localStorage.getItem(GATSBY_I18NEXT_KEY),
  )
  if (!i18nextLanguage) {
    return path
  }

  if (i18nextLanguage === DEFAULT_LANGUAGE) return path

  return `/${i18nextLanguage}${path.startsWith("/") ? "" : "/"}${path}`
}

export function getLanguage() {
  return isBrowser
    ? normalizeLanguage(localStorage.getItem(GATSBY_I18NEXT_KEY))
    : undefined
}
